import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeechBubbleDots20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSpeechBubbleDots20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.45 15.5V14H3.5a1 1 0 0 1-1-1V5.5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1V13a1 1 0 0 1-1 1h-6.22l-.407.32-3.423 2.692zm10.05 0h-5.7l-4.232 3.328a1 1 0 0 1-1.618-.787V15.5H3.5A2.5 2.5 0 0 1 1 13V5.5A2.5 2.5 0 0 1 3.5 3h13A2.5 2.5 0 0 1 19 5.5V13a2.5 2.5 0 0 1-2.5 2.5m-10-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3.5 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4.5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeechBubbleDots20);
